import { scrollIntoViewHoriz } from '../utils/horizontal-scroll.js';
import { debounce } from '../utils/debounce.js';

export default function initLinksNav() {
  const lists = document.querySelectorAll('.links .links__list');
  if (!lists.length) return;

  lists.forEach((list) => {
    if (list.dataset.linksNavInit === '1') return;
    list.dataset.linksNavInit = '1';

    const moveTo = (link, align = 'center') => {
      if (!link) return;
      scrollIntoViewHoriz(link, list, align);
    };

    const active = list.querySelector('.links__link--active');
    if (active) {
      requestAnimationFrame(() => {
        moveTo(active, 'center');
      });
    }

    list.querySelectorAll('.links__link').forEach((link) => {
      link.addEventListener(
        'click',
        () => {
          requestAnimationFrame(() => {
            moveTo(link, 'nearest');
          });
        },
        { passive: true }
      );
    });

    const onResize = debounce(() => {
      const currentActive = list.querySelector('.links__link--active');
      if (currentActive) {
        moveTo(currentActive, 'center');
      }
    }, 120);

    window.addEventListener('resize', onResize);
  });
}
